import {
    lazyAddLinkIdToLinksIdContainer,
    lazyCreateLinksIdContainer,
    lazyDoesLinksIdContainerExist,
    lazyUpdateLinkContainerIdOfLink,
    LinksIdContainerArray,
    SharingLinkInfo,
} from 'owa-link-data';

export async function rectifyLinksIdContainerState(
    composeLinkContainerId: string,
    sharingLink: SharingLinkInfo,
    isLinkPreviewable
): Promise<void> {
    if (
        composeLinkContainerId !== sharingLink.linksContainerId &&
        composeLinkContainerId &&
        isLinkPreviewable
    ) {
        const updateLinkContainerIdOfLink = await lazyUpdateLinkContainerIdOfLink.import();
        updateLinkContainerIdOfLink(sharingLink, composeLinkContainerId);

        const doesLinksIdContainerExist = await lazyDoesLinksIdContainerExist.import();
        const isLinksIdContainerCreated = doesLinksIdContainerExist(composeLinkContainerId);

        if (!isLinksIdContainerCreated) {
            const createLinksIdContainer = await lazyCreateLinksIdContainer.import();
            createLinksIdContainer(composeLinkContainerId);
        }

        const addLinkIdToLinksIdContainer = await lazyAddLinkIdToLinksIdContainer.import();
        addLinkIdToLinksIdContainer(
            sharingLink.linkId,
            composeLinkContainerId,
            LinksIdContainerArray.linkIds
        );
    }
}
